export function createMainStateDomainWrapper(state) {
  return { state };
}
